import styled, { css } from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { HeadingBoldH5 } from '@/shared/ui/typography2';

export const SectionTitle = styled(HeadingBoldH5)`
  @media (max-width: 768px) {
    ${brandIsPh &&
    css`
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
    `}
  }
`;

export const Section = styled.div<{ $hasScroll?: boolean; $rows?: number }>`
  position: relative;
  z-index: 0;
  --per-row: 3;
  --mobile-rows: 1;
  display: grid;
  grid-template-columns: repeat(var(--per-row), minmax(0, 1fr));
  grid-auto-flow: dense;
  gap: 8px;
  margin-bottom: 8px;
  overflow: hidden;

  @media (max-width: 758px) {
    position: static;
    gap: 14px;
  }

  ${({ $hasScroll }) =>
    $hasScroll &&
    css`
      @media (max-width: 768px) {
        grid-auto-flow: column;
        grid-template-columns: none;
        grid-template-rows: repeat(var(--mobile-rows), 152px);
        grid-auto-columns: 114px;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-behavior: smooth;
        margin: 0 18px;

        &::-webkit-scrollbar {
          display: none;
        }

        ${brandIsPh &&
        css`
          margin: 0 12px;
        `}
      }
    `}

  ${({ $rows }) =>
    $rows &&
    css`
      --mobile-rows: ${$rows};
    `}

  @media (min-width: 800px) {
    --per-row: 5;
    gap: 12px;
  }

  @media (min-width: 900px) {
    --per-row: 6;
    gap: 12px;
  }

  @media (min-width: 1000px) {
    --per-row: 6;
    gap: 24px;
  }
  @media (min-width: 1158px) {
    --per-row: 6;
    gap: 24px;
    grid-template-columns: repeat(var(--per-row), 168px);
    grid-auto-rows: 224px;
  }
`;

export const SectionBlocks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 24px;

  @media (max-width: 768px) {
    margin-top: 16px;
    padding-right: 18px;
    padding-left: 18px;

    ${brandIsPh &&
    css`
      margin-top: 12px;
      margin-bottom: 12px;
      padding-right: 12px;
      padding-left: 12px;
    `}
  }
`;

export const SectionViewAll = styled.a<{ $count?: number }>`
  display: flex;
  background: linear-gradient(90deg, #ff9500 0%, #ff5e00 100%);
  height: 40px;
  align-items: center;
  padding: 0 24px;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  &:after {
    content: '${(props) => props.$count}';
    color: #fff674;
    margin-left: 8px;
  }
  @media (max-width: 768px) {
    height: 28px;
    padding: 0 8px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 15.6px */

    ${brandIsPh &&
    css`
      font-weight: 500;
    `}
  }
  &:hover {
    opacity: 0.9;
  }
`;
